import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Loader from "../../Loading/Loader";

export default function Popup({
  open,
  onClose,
  Disagree,
  Agree,
  Title,
  loading,
}) {
  return (
    <div>
      <Dialog
        open={open}
        onClose={() => onClose(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{Title}</DialogTitle>
        <DialogActions>
          <Button onClick={() => onClose(false)} autoFocus>
            {Disagree}
          </Button>
          <Button onClick={() => onClose(true)}>{Agree}</Button>
          {loading && <Loader type="spin" color="cyan" />}
        </DialogActions>
      </Dialog>
    </div>
  );
}
